import NodeTemplate from './NodeTemplate'

export default NodeTemplate